import { Component, Input, HostBinding, forwardRef, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

interface ChipOption {
  display: string
  value: string
}

@Component({
  host: {
    'class': 'fw-chip-selector',
    'test-id': 'fw-chip-selector',
    '(blur)': 'onTouched()',
  },
  encapsulation: ViewEncapsulation.None,
  selector: 'fw-chip-selector',
  templateUrl: './fw-chip-selector.component.html',
  styleUrls: ['./fw-chip-selector.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    useExisting: forwardRef(() => FwChipSelectorComponent),
    multi: true,
  }],
})
export class FwChipSelectorComponent implements ControlValueAccessor {
  @Input() chipsToShow? = 7;
  @Input() options: ChipOption[];

  selectedOptions: Set<ChipOption> = new Set();
  showAllOptions = false;

  /** ControlValueAccessor */
  onChange: (value: Set<ChipOption>) => void = () => { } // eslint-disable-line @typescript-eslint/no-empty-function
  onTouched: Function = () => { } // eslint-disable-line @typescript-eslint/no-empty-function

  static nextId = 0;
  @HostBinding() id = `fw-chip-collapsing-${FwChipSelectorComponent.nextId++}`;

  get displayedOptions(): ChipOption[] {
    return this.showAllOptions ? this.options : this.options.slice(0, this.chipsToShow);
  }
  get hiddenOptions(): number {
    return this.options.length - this.displayedOptions.length;
  }
  get value(): Set<ChipOption> {
    return this.selectedOptions;
  }
  set value(value: Set<ChipOption>) {
    this.selectedOptions = value;
  }

  /* ControlValueAccessor */
  writeValue(value: Iterable<ChipOption>): void {
    this.selectedOptions = value instanceof Set ? value : new Set(value);
  }

  registerOnChange(fn: (value: Set<ChipOption>) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onTouched = fn;
  }
  /**/

  selectOption(option: ChipOption): void {
    if (this.selectedOptions.has(option)) {
      this.selectedOptions.delete(option);
    } else {
      this.selectedOptions.add(option);
    }
    
    this.onChange(this.value);
  }
}
